import RankingIcon from 'shared/experiments/components/CswProductRankingLabel/RankingIcon'
import {
  EXPERIMENT_VARIATION,
  HOME_CSW_RANKING,
  PDP_CSW_RANKING,
} from 'shared/experiments/consts'
import BorderedText from 'views/components/atoms/BorderedText'
import Experiment from 'views/components/utils/optimizely/Experiment'
import './CswProductRankingLabel.scss'

const CswProductRankingLabel = ({ rank }: { rank: number }) => {
  return (
    <Experiment
      classNames={`o-ProductSliderItem__ranking l-flex l-flex--center`}
      names={[PDP_CSW_RANKING, HOME_CSW_RANKING]}
    >
      {({ isEnabled, variant }) => {
        if (isEnabled) {
          if (variant === EXPERIMENT_VARIATION.V2) {
            return <>{rank}</>
          }
          if (variant === EXPERIMENT_VARIATION.V3) {
            return (
              <BorderedText
                bgcolor="greyLight"
                bordercolor="greyLight"
                skewed
                notexttransform
                smaller
              >
                Topseller {rank}
              </BorderedText>
            )
          }
          if (variant === EXPERIMENT_VARIATION.V4) {
            return (
              <>
                <span>{rank}</span>
                <RankingIcon />
              </>
            )
          }
        } else {
          return null
        }
      }}
    </Experiment>
  )
}

export default CswProductRankingLabel
